package com.svdsak.components.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.svdsak.components.sections.Footer
import com.svdsak.style.PageContentStyle
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.vh

@Composable
fun PageLayout(
    title: String,
    content: @Composable ColumnScope.() -> Unit
) {

    val breakpoint = rememberBreakpoint()

    LaunchedEffect(title) {
        document.title = "SVDSAK- KOWTHALAM - $title"
    }

    Box(
        Modifier
            .fillMaxWidth()
            .maxHeight(100.vh)
            .gridTemplateRows { size(1.fr); size(minContent) }
    ) {

        Column(
            Modifier
                .height(95.vh)
                .fillMaxWidth()
                .gridRow(1)
        ) {
            Column(
                PageContentStyle.toModifier(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                content()
            }
            Footer(Modifier.height(5.vh).fillMaxWidth(), breakpoint)
        }
    }
}